import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modal, giftModal, cart } from 'actions';
import { Form } from 'react-final-form';
import Portal from 'common/components/Portal';
import Field from 'common/components/Form/Field';
import { t } from 'translates';
import Icon from 'common/components/Icon';
import PairsValidation from 'common/components/Form/extensions/checkPairValidation';
import classNames from 'classnames';
import Spinner from 'common/components/Spinner';
import DeliveryInformation from '../components/DeliveryInformation';
import currencyCode from 'common/helpers/currencyCode';
const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

class GiftModal extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      modal: PropTypes.shape({
        show: PropTypes.func,
        hide: PropTypes.func,
      }),
      giftModal: PropTypes.shape({
        countries: PropTypes.func,
        states: PropTypes.func,
        saveData: PropTypes.func,
        giftUpdate: PropTypes.func,
        setFormat: PropTypes.func,
      }),
      cart: PropTypes.shape({
        addToCart: PropTypes.func,
      }),
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
    giftModal: PropTypes.object.isRequired,
    modal: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      submitSpinner: false,
      delivery: 'me',
    };

    this.domainCheck = window.drupalSettings
      && window.drupalSettings.domainId
      && window.drupalSettings.domainId === 'lecole_japan';
    this.pairsValidation = {};

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeCountry = this.onChangeCountry.bind(this);
    this.onSubmitFalse = this.onSubmitFalse.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.hideError = this.hideError.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.close = this.close.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.onChangeFormat = this.onChangeFormat.bind(this);
    this.onChangeTextarea = this.onChangeTextarea.bind(this);
    this.removeEmotes = this.removeEmotes.bind(this);
  }

  componentDidMount() {
    this.pairsValidation = new PairsValidation();
  }

  onSubmit(form) {
    if (!this.pairsValidation.pairsExists) {
      this.showMessage(t('At least one pair of name fields have to be filled.', DT_GIFT), 'type-error');
      return;
    }

    const hash = (+new Date).toString(36);
    const {
      giftModal: {
        dialog,
        gifts
      }
    } = this.props;
    const data = {
      ...gifts,
      ...dialog,
      ...form,
    };

    if (data.message) {
      data.message = this.removeEmotes(data.message);
    }

    this.props.actions.cart.addToCart(1, hash, 'gc_products', data);
    this.props.actions.modal.hide('gift.dialog');
    this.showMessage(t('Gift code was added to your selection.', DT_GIFT), 'type-success');
    this.setState({
      delivery: 'me',
    });

    const currentGift = gifts.filter(gift => dialog.codeId.includes(gift.id));
    let product = {};
    if (currentGift !== undefined && currentGift.length > 0) {
      product.price = parseFloat(currentGift[0].price) + parseFloat(currentGift[0].tax);
      product.item_id = currentGift[0].id;
    } else {
      product.item_id = dialog.codeId;
      product.price = parseFloat(dialog.price) + parseFloat(dialog.tax);
    }
    product.item_name = 'Gift Certificate';
    product.item_type = 'Gift Certificate';
    product.item_category = 'Gift Certificate';
    product.quantity = 1;
    product.course_participants = 'N/A';
    product.course_language = 'N/A';
    product.course_date = 'N/A';
    product.course_time = 'N/A';
    product.item_list_id = pg_type;

    window.dataLayer && dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: currencyCode,
        items: [
          product
        ]
      }
    });

    document.getElementsByTagName('html')[0].classList.toggle('state--cart-opened');
    this.props.actions.modal.show('cart.dialog');
    if (!!document.querySelector('.state--cart-opened')) {
      window.dataLayer && window.dataLayer.push({event: "myShoppingBag"});
    }
  }

  toggleSpinner(spinnerName) {
    this.setState({
      [spinnerName]: !this.state[spinnerName],
    });
  }

  onChangeCountry(iso_code) {
    this.toggleSpinner('submitSpinner');
    this.props.actions.giftModal.states(iso_code)
      .then(() => this.toggleSpinner('submitSpinner'));
  }

  onSubmitFalse(event, message = t('Mandatory fields must be filled in', DT_GIFT)) {
    this.showMessage(message, 'type-error');
  }

  onChangeRadio(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onChangeFormat(event) {
    this.props.actions.giftModal.setFormat(event.target.value);
  }

  onChangeTextarea(event) {
    let val = event.target.value;
    event.target.value = this.removeEmotes(val);
  }

  removeEmotes(msg) {
    const ranges = [
      '\u00a9',
      '\u00ae',
      '[\u2000-\u3300]',
      '\ud83c[\ud000-\udfff]',
      '\ud83d[\ud000-\udfff]',
      '\ud83e[\ud000-\udfff]'
    ];

    let val = msg;

    val = val.replace(new RegExp(ranges.join('|'), 'g'), '');
    return val;
  }

  onChangeSelect(event) {
    const {
      giftModal: {
        gifts,
      },
    } = this.props;

    gifts.forEach((gift) => {
      if (gift.id === event.target.value) {
        this.props.actions.giftModal.giftUpdate(gift);
        return false;
      }
    });
  }

  hideError(e) {
    e.preventDefault();
    this.props.actions.modal.hide('gift.error');
  }

  onInput(e) {
    e.preventDefault();
    if (e.target.getAttribute('pairname')) {
      this.pairsValidation.checkPairValidity(e.target);
    }
  }

  close(e) {
    e.preventDefault();
    this.setState({
      delivery: 'me',
    }, () => {
      this.props.actions.modal.hide('gift.dialog');
    });
    return false;
  }

  showMessage(message, type) {
    this.props.actions.modal.show('gift.error', {
      message,
      hideButton: true,
      type,
    });

    const giftModalTimeout = setTimeout(() => {
      this.props.actions.modal.hide('gift.error');
      clearTimeout(giftModalTimeout);
    }, 8000);
  }

  render() {
    const siteLang = document.documentElement.lang;
    const {
      giftModal: {
        countries,
        states,
        dialog: {
          codeType,
          codeId,
          productTitle,
          codePrice,
        },
        gifts,
        formatTypes,
        format,
      },
      actions: {
        giftModal: {
          countries: getCountries,
        },
      },
      modal,
    } = this.props;

    const {
      delivery,
      submitSpinner,
    } = this.state;

    return (
      <div>
        {(({ isOpen, message, hideButton, type = 'type-error' }) => isOpen && (
          <div className={'gift-modal-dialog__error-message ' + type}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
            <a
              href="#"
              onClick={this.hideError}
              style={{
                display: hideButton ? 'none' : 'inline-block',
              }}
              className="gift-modal-dialog__error-message-close"
            >
              <Icon name="close" />
            </a>
          </div>
        ))(modal['gift.error'])}
        <Portal
          id="gift.dialog"
          className="gift-modal-dialog__portal"
          onClose={this.close}
          isOpen
        >
          <div className="gift-modal-dialog">
            <header className="gift-modal-dialog__header">
              <div className="container">
                <span className="gift-modal-dialog__title">{t('Gift certificate', DT_GIFT)}</span>

                <div className="gift-modal-dialog__close">
                  <button onClick={this.close} />
                </div>
              </div>
            </header>

            <Form
              onSubmit={this.onSubmit}
              initialValues={{
                delivery: 'me',
                format: formatTypes.includes('e_card') ? 'e-card' : 'gift box',
                civility: 'mr',
                delivery_civility: 'mr',
              }}
              noValidate
            >
              {({ handleSubmit, form, invalid }) => (
                <form
                  onSubmit={handleSubmit}
                  id="giftModal"
                >
                  {submitSpinner && (
                    <Spinner />
                  )}
                  <section className="gift-modal-dialog__body">
                    <div className="container">
                      <div className="gift-modal-dialog__col gift-modal-dialog__col--odd gift-modal-dialog__col--1">
                        <div className="gift-modal-dialog__block gift-modal-dialog__block--odd">
                          {codeType === 'product' ? (
                            <Fragment>
                              <div className="gift-modal-dialog__block-title">
                                1. {t('Course', DT_GIFT)}
                              </div>
                              <div className="gift-modal-dialog__block-content">
                                <div className="gift-modal-dialog__course-name">{`${productTitle} (${codePrice})`}</div>
                              </div>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <div className="gift-modal-dialog__block-title">
                                1. {t('Select amount', DT_GIFT)}
                              </div>
                              <div className="gift-modal-dialog__block-content">
                                <Field
                                  type="select"
                                  name="gift"
                                  defaultValue={codeId}
                                  value={codeId}
                                  onChange={this.onChangeSelect}
                                  className="gift-modal-dialog__select-amount"
                                >
                                  {gifts.map(({ id, price_amount: price }) => (
                                    <option
                                      key={id}
                                      value={id}
                                    >
                                      {price}
                                    </option>
                                  ))}
                                </Field>
                              </div>
                            </Fragment>
                          )}
                        </div>
                        <div className="gift-modal-dialog__block gift-modal-dialog__block--even">
                          <div className="gift-modal-dialog__block-title">
                            2. {t('Select the delivery', DT_GIFT)}
                          </div>
                          <div className="gift-modal-dialog__block-content">
                            <div className="radio-group gift-modal-dialog__select-delivery">
                              <Field
                                type="radio"
                                name="delivery"
                                defaultChecked
                                value="me"
                                label={t('Send to me', DT_GIFT)}
                                onChange={this.onChangeRadio}
                              />
                              <Field
                                type="radio"
                                name="delivery"
                                value="recipient"
                                label={t('Send to recipient', DT_GIFT)}
                                onChange={this.onChangeRadio}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="gift-modal-dialog__block gift-modal-dialog__block--odd">
                          <div className="gift-modal-dialog__block-title">
                            3. {t('Select the format', DT_GIFT)}
                          </div>
                          <div className="gift-modal-dialog__block-content">
                            <div className="radio-group gift-modal-dialog__select-format">
                              {formatTypes.includes('e_card') && <Field
                                type="radio"
                                name="format"
                                defaultChecked
                                value="e-card"
                                label={t('e-card', DT_GIFT)}
                                onChange={this.onChangeFormat}
                              />}
                              {formatTypes.includes('gift_box') && <Field
                                type="radio"
                                name="format"
                                value="gift box"
                                defaultChecked={!formatTypes.includes('e_card')}
                                label={
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: t('<span>gift box<br />(a digital copy will also be e-mailed to you)</span>', DT_GIFT)
                                    }}>
                                  </span>
                                }
                                onChange={this.onChangeFormat}
                              />}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={classNames(
                          'gift-modal-dialog__col',
                          'gift-modal-dialog__col--even',
                          {
                            'gift-modal-dialog__col--1': format === 'gift box',
                            'gift-modal-dialog__col--2': format !== 'gift box',
                          }
                        )}
                      >
                        <div className="gift-modal-dialog__block gift-modal-dialog__block--offered gift-modal-dialog__block--even">
                          <div className="gift-modal-dialog__block-title">
                            4. {t('Offered to', DT_GIFT)}
                          </div>
                          <div className="gift-modal-dialog__block-content">
                            <div className="radio-group gift-modal-dialog__civility">
                              <Field
                                type="radio"
                                name="civility"
                                defaultChecked
                                value="mr"
                                label={this.domainCheck ? t('Male', DT_GIFT) : t('Mr', DT_GIFT)}
                              />
                              <Field
                                type="radio"
                                name="civility"
                                defaultChecked={false}
                                value="ms"
                                label={this.domainCheck ? t('Female', DT_GIFT) : t('Ms', DT_GIFT)}
                              />
                            </div>
                            { this.domainCheck ? (
                              <Fragment>
                                <div className="gift-modal-dialog__field-group">
                                  <Field
                                    type="text"
                                    name="last_name_kanji"
                                    data-name="lKanji"
                                    placeholder={t('last name (Kanji)', DT_GIFT)}
                                    required={ drupalSettings.path.currentLanguage !== 'en' }
                                    pattern="kanji"
                                    value=""
                                    pairname="kanji"
                                    onInput={this.onInput}
                                  />
                                  <Field
                                    type="text"
                                    name="first_name_kanji"
                                    data-name="fKanji"
                                    placeholder={t('first name (Kanji)', DT_GIFT)}
                                    required={ drupalSettings.path.currentLanguage !== 'en' }
                                    pattern="kanji"
                                    value=""
                                    pairname="kanji"
                                    onInput={this.onInput}
                                  />
                                </div>
                                { drupalSettings.path.currentLanguage === 'ja' && (
                                  <div className="gift-modal-dialog__field-group">
                                    <Field
                                      type="text"
                                      name="last_name_romaji"
                                      data-name="lromaji"
                                      placeholder={t('last name (Romaji)', DT_GIFT)}
                                      required
                                      pattern="a"
                                      value=""
                                      pairname="romaji"
                                      onInput={this.onInput}
                                    />
                                    <Field
                                      type="text"
                                      name="first_name_romaji"
                                      data-name="fromaji"
                                      placeholder={t('first name (Romaji)', DT_GIFT)}
                                      required
                                      pattern="a"
                                      value=""
                                      pairname="romaji"
                                      onInput={this.onInput}
                                    />
                                  </div>
                                )}
                                { drupalSettings.path.currentLanguage === 'en' && (
                                  <div className="gift-modal-dialog__field-group">
                                    <Field
                                      type="text"
                                      name="last_name"
                                      placeholder={t('last name', DT_GIFT)}
                                      pattern="a"
                                      value=""
                                      required
                                      pairname="eng"
                                      onInput={this.onInput}
                                    />
                                    <Field
                                      type="text"
                                      name="first_name"
                                      placeholder={t('first name', DT_GIFT)}
                                      pattern="a"
                                      value=""
                                      required
                                      pairname="eng"
                                      onInput={this.onInput}
                                    />
                                  </div>
                                )}
                              </Fragment>
                            ) : (
                              <div className="gift-modal-dialog__field-group">
                                <Field
                                  type="text"
                                  name="first_name"
                                  placeholder={t('first name', DT_GIFT)}
                                  required pattern="a"
                                  value=""
                                  pairname="eng"
                                  onInput={this.onInput}
                                />
                                <Field
                                  type="text"
                                  name="last_name"
                                  placeholder={t('last name', DT_GIFT)}
                                  required pattern="a"
                                  value=""
                                  pairname="eng"
                                  onInput={this.onInput}
                                />
                              </div>
                            ) }

                            {(format === 'gift box' || delivery === 'recipient') &&
                            <div className={delivery === 'recipient' ? 'gift-modal-dialog__field-group' : ''}>
                              {((format === 'gift box' && delivery === 'recipient') || (format === 'e-card' && delivery === 'recipient')) && (<Field
                                type="email"
                                name="email"
                                placeholder={t('Email address', DT_GIFT)}
                                required
                                pattern="@"
                                value=""
                              />)}
                              {delivery === 'recipient' && (<Field
                                type="text"
                                name="from"
                                placeholder={t('From', DT_GIFT)}
                                required
                                pattern="a+japan"
                                value=""
                              />)}
                            </div>}

                            <Field
                              type="textarea"
                              name="message"
                              onChange={this.onChangeTextarea}
                              placeholder={t('Message (optional)', DT_GIFT)}
                              defaultValue=""
                              maxLength={128}
                            />
                          </div>
                        </div>
                      </div>
                      {format === 'gift box' && (
                        <div className="gift-modal-dialog__col gift-modal-dialog__col--odd gift-modal-dialog__col--1">
                          <div className="gift-modal-dialog__block gift-modal-dialog__block--delivery gift-modal-dialog__block--odd">
                            <div className="gift-modal-dialog__block-title">
                              5. {t('Delivery informations', DT_GIFT)}
                            </div>
                            <div className="gift-modal-dialog__block-content">
                              <DeliveryInformation
                                countries={countries}
                                states={states}
                                onChangeCountry={this.onChangeCountry}
                                getCountries={getCountries}
                                checkPairValidity={this.pairsValidation.checkPairValidity}
                                pairValidationInit={this.pairsValidation.init}
                                form={form}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </section>
                  <footer className="gift-modal-dialog__footer">
                    <button
                      type="submit"
                      onClick={invalid ? this.onSubmitFalse : () => {}}
                      className={classNames('gift-modal-dialog__button', {
                        'disabled' : invalid,
                      })}
                    >
                      <Icon name="checked" />
                      <span className="gift-modal-dialog__button-text--desktop">
                        {t('Offer gift certificate', DT_GIFT)}
                      </span>
                      <span className="gift-modal-dialog__button-text--mobile">
                        {t('Offer now', DT_GIFT)}
                      </span>
                    </button>
                  </footer>
                </form>
              )}
            </Form>
          </div>
        </Portal>
      </div>
    );
  }
}

export default connect(
  state => ({
    isOpen: state.modal['gift.dialog'].isOpen,
    giftModal: state.giftModal,
    modal: state.modal,
  }),
  dispatch => ({
    actions: {
      modal: bindActionCreators(modal, dispatch),
      giftModal: bindActionCreators(giftModal, dispatch),
      cart: bindActionCreators(cart, dispatch),
    },
  }),
)(GiftModal);
